import { useTranslation } from "react-i18next";

import Progress from "../../../ExamComponents/Progress";

export default function ExamProgress({ row }) {
	const { t } = useTranslation();

	return (
		<Progress
			allItems={row.totalQuestions}
			resolvedItems={row.resolvedQuestions}
			unit={t("units.questions")}
		/>
	);
}
